export const ICON_NEW = "/assets/img/icon-new.svg";

export const DEFAULT_AVATAR = "/assets/img/avt2.png";
